<template>
    <v-app id="usertracking">
        <v-app-bar
                app
                clipped-left
                dark
        >
            <v-toolbar-title>
                <div class="sticky-logo mt-5 mb-3" align="center" justify="center">
                    <h1><span class="header">Border</span>Ex</h1>
                </div>
            </v-toolbar-title>
            <v-spacer />
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-2" min-width="0" text @click="login"  v-on="on">
                        <v-icon dark>mdi-power</v-icon>
                    </v-btn>
                </template>
                <span>Login</span>
            </v-tooltip>
        </v-app-bar>
        <v-content>
            <v-container
                    fluid
                    fill-height
            >
                <v-layout
                        align-center
                        justify-center
                >
                    <v-flex
                            xs12
                            sm10
                            md8
                    >
                        <tracking/>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
  import Tracking from "./dashboard/component/Tracking";


  export default {
    name: "UserTracking",
    components: {Tracking},
    data: () => ({}),
      methods: {
        login() {
            window.location = "https://admin.borderex.in/#/login";
        }
      }
  };
</script>
<style lang="sass">
    .sticky-logo
        color: #fff
        padding: 0
        margin: 0
        font-size: 26px
        font-weight: bold
        line-height: 1
        span
            color: #3ec1d5
</style>